<div class="walkthrough-container">
    <div class="left">
        <div class="left-title">Table of Contents</div>
        <mat-accordion class="accordian" >
            <mat-expansion-panel *ngFor="let m of menu" class="accordian"  [expanded]="m.expanded === true"  >
                <mat-expansion-panel-header (click)="setStep(m)">
                    <mat-panel-title class="title">
                        {{m.name}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="sub-container" >
                    <div *ngFor="let subItem of m.subItems" (click)="selectSubItem(subItem)" [class.accent-container]="subItem.value === activeItem">
                        <div class="subItem" >{{subItem.name}}</div>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
    
    <div class="right">
        <div class="right-title">
            Welcome to cloudServe
            <!-- <mat-icon svgIcon="x" class="close-icon" (click)="closeDialog()"></mat-icon> -->
            <button mat-icon-button class="close-icon" (click)="closeDialog()"><mat-icon>close</mat-icon></button>
        </div>
        <div class="divider"></div>
        <div class="image"><img src={{gif}} /></div>
        <div class="description" [innerHtml]="description"></div>
    </div>

    <div class="button-container">
        <button mat-button-icon class="button" [disabled]="disableBack === true" (click)="prevStep()"><img src="../../../assets/walkthrough-images/arrow-left.svg"></button>
        <button mat-button-icon class="button" [disabled]="disableNext === true" (click)="nextStep()"><img src="../../../assets/walkthrough-images/arrow-right.svg"></button>
    </div>
</div>